<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Are you sure?</modal-header>
        </div>
        Are you sure you want to delete this creative unit?
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm" cancelText="No, go back" confirmText="Yes, delete"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_delete_creativeUnit',
  mixins: [modalMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta
  },
  props: {
    show: Boolean,
    confirmId: String
  },
  data: () => ({}),
  mounted () {},
  computed: {},
  methods: {
    confirm () {
      this.deleteRow(this.confirmId)
      this.$emit('confirmDeleteUnit', this.confirmId)
      this.close()
    },
    deleteRow (rowid) {
      const row = document.getElementById(rowid)
      row.parentNode.removeChild(row)
      const data = {
        id: this.$route.params.id,
        action: 'delete',
        units: [this.confirmId]
      }
      this.updateBulkCreative(data).then(() => {
        this.finishLoading()
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
    }
  }
}

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-delete-creativeUnit.vue